import React, { useEffect, useState, useCallback } from "react";
import { Tab, Tabs } from '@mui/material';
import { ButtonContain, Card, CardContain, TabsContain } from "../../style/Home";
import Grid from "@mui/material/Grid";
import Filter from "../../Components/filters";
import { useDispatch, useSelector } from "react-redux";
import { GetDashboardData } from "../../services/dashboardService";
import { resetFilter } from "../../features/filterSlice";
import {
  HoReportRadio,
} from "../../style/table";
import {
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { GetExcelFile } from "../../services/hoReportService";
import { toast, ToastContainer } from "react-toastify";
import "../../css/hoReport.css"
import { GuidelineContain } from "../../style/AM/MoMStatusUpdate";
import { Loader } from "../../utils/loader";

function HoReport() {
  const [isSticky, setIsSticky] = useState(false);
  const [filterValues, setFilterValues] = useState({});
  const [loader, setLoader] = useState(false);
  const filtersValue = useSelector((state) => state.filterData);
  const [resetTrigger, setResetTrigger] = useState(Date.now());
  const dispatch = useDispatch();
  const [isDispatched, setIsDispatched] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fileType, setFileType] = useState("");
  const [value, setValue] = useState("mvrReports");

  useEffect(() => {
    dispatch(resetFilter());
    setIsDispatched(true);
  }, [dispatch]);
  
  const handleRadioChange = (event) => {
    const selectedReport = event.target.value;
    setSelectedValue(selectedReport);
    if (selectedReport) {
      setFileType(selectedReport);
    }
  };

  const handleDownload = async (mimeType) => {
    try {
      setIsLoading(true);
      console.log(mimeType, " got my mim type")
      console.log(selectedValue, " got my selected value")
      var payload;
      if (value === "mvrReports"){
        payload = {
          mimeType, 
          financialYear: filtersValue.financialYear || [],
          period: filtersValue.period || [],
          dealerCodes: filtersValue.dealerCodes || [],
          regions: filtersValue.regions || [],
          zones: filtersValue.zones || [],
          areas: filtersValue.areas || [],
        };
      }else {
        payload = {
          mimeType, 
          financialYear: filtersValue.financialYear || [],
          period: filtersValue.period || [],
          dealerCodes: filtersValue.dealerCodes || [],
          frequency: filtersValue.frequency || "",
          regions: filtersValue.regions || [],
          zones: filtersValue.zones || [],
          areas: filtersValue.areas || [],
        };
      }

      const response = await GetExcelFile({
        reportType: selectedValue,
        payload: payload,
      });

      if (response?.success && response?.url) {
        const link = document.createElement("a");
        link.href = response.url;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.error("Download failed:", error);
      toast.error("Failed to download file. Please try again.");
    } finally {
      setIsLoading(false);
      setFileType("");
      setSelectedValue("");
    }
  };


  const handleFileTypeChange = async (event) => {
    const selectedType = event.target.value;
    setFileType(selectedType);

    if (selectedType) {
      await handleDownload(selectedType);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleFilterChange = (filterKey, value) => {
    setFilterValues((prev) => ({
      ...prev,
      [filterKey]: value, 
    }));
  };

  const handleSearch = async () => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }
  
  const handleReset = () => {
    dispatch(resetFilter());
    setResetTrigger(Date.now());
    setTimeout(() => setResetTrigger(false), 0);
  };

  // my new code
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setFileType("")
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} />
      <TabsContain className='TabsContain'>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="tabs example"
          className={`HomeTabs ${isSticky ? "StickyShadow" : ""}`}
        >
          <Tab label="MVR Reports" value="mvrReports" />
          <Tab label="BMVR Reports" value="bmvrReports" />
        </Tabs>
      </TabsContain>
      {value == "mvrReports" && (
        <>
          <CardContain>
            <Card mt={1} className="Filter_bg">
              <Grid container spacing={1}>
                <Filter
                  onFilterChange={handleFilterChange}
                  reset={resetTrigger}
                ></Filter>
                <Grid item xs={12}>
                  <ButtonContain>
                    <button onClick={handleSearch} className="SearchButton">
                      Search
                    </button>
                    <button onClick={handleReset} className="ResetButton">
                      Reset
                    </button>
                    {/* <button className="ExportButton">
                      <img src={ExcelIcon} alt="Excel icon" />
                    </button> */}
                  </ButtonContain>
                </Grid>
              </Grid>
            </Card>
          </CardContain>

          <CardContain>
            <Card mt={2}>
              <GuidelineContain>
              <div className="Guidelines">
                  <p>
                    <span>Please Select the Report and Download: </span>{" "}
                  </p>
                </div>
              </GuidelineContain>
              <HoReportRadio>
                {[
                  "MVR Visit Report",
                  "MVR Evaluation Status Report",
                  "MVR MoM Status Report",
                  "MoM Escalation Report",
                ].map((option, index) => (
                  <label key={index}>
                    <input
                    className="download-option"
                      type="radio"
                      name="options"
                      value={option}
                      checked={selectedValue === option}
                      onChange={handleRadioChange}
                      style={{zIndex:-1}}
                    />
                    {option}
                  </label>
                ))}

                {selectedValue && (
                  <FormControl sx={{ minWidth: 70 }} size="small">
                    <Select
                      className="download-select"
                      value={fileType}
                      onChange={handleFileTypeChange}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return "Download";
                        }
                        return "Download";
                      }}
                      disabled={isLoading || !selectedValue}
                      
                      sx={{
                        cursor: "pointer",
                        backgroundColor: "#009000",
                        color: "white",
                        borderRadius: "8px",
                        padding: "2px",
                        border: "none",
                      }}
                    >
                      <MenuItem value="csv"sx={{ cursor: "pointer" }}>
                        Download CSV
                      </MenuItem>
                      <MenuItem value="xlsx"sx={{ cursor: "pointer" }}>
                        Download Excel
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              </HoReportRadio>
            </Card>
          </CardContain>
        </>
      )}

      {value == "bmvrReports" && (
        <>
          <CardContain>
            <Card mt={1} className="Filter_bg">
              <Grid container spacing={1}>
                <Filter
                  onFilterChange={handleFilterChange}
                  reset={resetTrigger}
                  showBmvrFrequency={true}
                ></Filter>
                <Grid item xs={12}>
                  <ButtonContain>
                    <button onClick={handleSearch} className="SearchButton">
                      Search
                    </button>
                    <button onClick={handleReset} className="ResetButton">
                      Reset
                    </button>
                    {/* <button className="ExportButton">
                      <img src={ExcelIcon} alt="Excel icon" />
                    </button> */}
                  </ButtonContain>
                </Grid>
              </Grid>
            </Card>
          </CardContain>

          <CardContain>
            <Card mt={2}>
            <GuidelineContain>
                <div className="Guidelines">
                  <p>
                    <span>Please Select the Report and  Download</span>{" "}
                  </p>
                </div>
              </GuidelineContain>
              <HoReportRadio>
                {[
                  "BVR Evaluation Status Report",
                  "BVR MoM Status Report",
                  "BVR MoM Escalation Report",
                ].map((option, index) => (
                  <label key={index}>
                    <input
                    className="download-option"
                      type="radio"
                      name="options"
                      value={option}
                      checked={selectedValue === option}
                      onChange={handleRadioChange}
                      style={{zIndex:-1}}
                    />
                    {option}
                  </label>
                ))}

                {selectedValue && (
                  <FormControl sx={{ minWidth: 70 }} size="small">
                    <Select
                      className="download-select"
                      value={fileType}
                      onChange={handleFileTypeChange}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return "Download";
                        }
                        return "Download";
                      }}
                      disabled={isLoading || !selectedValue}
                      
                      sx={{
                        cursor: "pointer",
                        backgroundColor: "#009000",
                        color: "white",
                        borderRadius: "8px",
                        padding: "2px",
                        border: "none",
                      }}
                    >
                      <MenuItem value="csv"sx={{ cursor: "pointer" }}>
                        Download CSV
                      </MenuItem>
                      <MenuItem value="xlsx"sx={{ cursor: "pointer" }}>
                        Download Excel
                      </MenuItem>
                    </Select>
                  </FormControl>
                )}
              </HoReportRadio>
            </Card>
          </CardContain>
        </>
      )}
      {loader && <Loader fullScreen={true} />}
    </>
  );
}

export default HoReport;
